export default {"src":"/_next/static/media/up-arrow.32c6c268.svg","height":330,"width":330};